/* SH Updated: July 2026 - PDP gallery ON BODY / PRODUCT VIEW tabs (lane 4b)
   Visibility is CSS-driven via .sh-view-pv on [data-product-images].

   SH Updated: August 2026 - per-colour PRODUCT VIEW (Devin's Aug 6 GO). PV slides
   now carry real colour groups when their alt is tagged '#color_x', so a tab switch
   must swap the Flickity cell set: this file dispatches sh:gallery-tab-change
   (bubbles to the product section, where theme.js re-initialises the slider with a
   tab-aware cellSelector) and hides the whole tab strip on colours that have no
   PRODUCT VIEW photos - Devin's own "hide PRODUCT VIEW when no product photos are
   uploaded" rule, applied per colour. theme.js stamps the current colour group on
   [data-product-images] as data-sh-image-set on every slider init; the
   MutationObserver on that attribute is what re-evaluates the strip after each
   colour change (observer callbacks run after theme.js finishes its re-init, so the
   read is never stale). */
(function () {
  'use strict';

  function refreshFlickity(container) {
    var slides = container.querySelector('[data-product-photos]');
    if (!slides || !window.Flickity) return;
    var el = slides.classList.contains('flickity-enabled')
      ? slides
      : slides.querySelector('.flickity-enabled');
    if (!el) return;
    var flkty = window.Flickity.data(el);
    if (!flkty) return;
    flkty.reloadCells();
    flkty.resize();
    flkty.select(0, false, true);
  }

  function initTabs(tabsEl) {
    var container = tabsEl.closest('[data-product-images]');
    if (!container) return;
    var buttons = tabsEl.querySelectorAll('.sh-gallery-tab');

    function pvSlideForCurrentColor() {
      var set = container.dataset.shImageSet;
      if (set) {
        return container.querySelector(
          '.sh-pv-slide[data-group="' + set + '"], .sh-pv-slide[data-group="__pv"]'
        );
      }
      // No colour group stamped (no image set on this product, or theme.js has not
      // initialised the slider yet): fall back to product-level presence.
      return container.querySelector('.sh-pv-slide');
    }

    function setView(view) {
      buttons.forEach(function (b) {
        b.setAttribute('aria-selected', b.dataset.shView === view ? 'true' : 'false');
      });
      var isPv = view === 'product-view';
      if (container.classList.contains('sh-view-pv') === isPv) return;
      container.classList.toggle('sh-view-pv', isPv);
      container.dispatchEvent(new CustomEvent('sh:gallery-tab-change', { bubbles: true }));
      // Fallback nudge for contexts where no section listener re-initialised the
      // slider (e.g. featured-product embeds); harmless after a real re-init.
      refreshFlickity(container);
    }

    function syncTabStrip() {
      var hasPv = !!pvSlideForCurrentColor();
      tabsEl.style.display = hasPv ? '' : 'none';
      if (!hasPv) setView('on-body');
    }

    tabsEl.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.sh-gallery-tab');
      if (!btn || btn.getAttribute('aria-selected') === 'true') return;
      setView(btn.dataset.shView);
    });

    // Zoom parity (Aug 2026): PRODUCT VIEW slides carry their own invisible zoom
    // overlay (.sh-pv-zoom). theme.js's Photoswipe indexes items by slide data-index,
    // which for pv slides points past the ON BODY set, so this handler opens the
    // lightbox itself, scoped to the pv slides currently visible (= current colour).
    container.addEventListener('click', function (evt) {
      var zoomBtn = evt.target.closest('.sh-pv-zoom');
      if (!zoomBtn) return;
      if (!window.PhotoSwipe || !window.PhotoSwipeUI_Default) return;
      var pswpEl = document.querySelector('.pswp');
      if (!pswpEl) return;

      var clickedSlide = zoomBtn.closest('.sh-pv-slide');
      var visibleSlides = Array.prototype.filter.call(
        container.querySelectorAll('.sh-pv-slide'),
        function (s) { return getComputedStyle(s).display !== 'none'; }
      );
      var items = [];
      var startIndex = 0;
      visibleSlides.forEach(function (slide, i) {
        var img = slide.querySelector('img[data-photoswipe-src]');
        if (!img) return;
        if (slide === clickedSlide) startIndex = items.length;
        items.push({
          msrc: img.currentSrc || img.src,
          src: img.getAttribute('data-photoswipe-src'),
          w: img.getAttribute('data-photoswipe-width'),
          h: img.getAttribute('data-photoswipe-height'),
          el: img,
          initialZoomLevel: 0.5,
        });
      });
      if (!items.length) return;

      // Same option set theme.Photoswipe uses, so the lightbox feels identical.
      var gallery = new window.PhotoSwipe(pswpEl, window.PhotoSwipeUI_Default, items, {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        index: startIndex,
        pinchToClose: false,
        preloaderEl: false,
        scaleMode: 'zoom',
        shareEl: false,
        tapToToggleControls: false,
        getThumbBoundsFn: function (index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = items[index].el.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      });
      gallery.init();
    });

    if (window.MutationObserver) {
      new MutationObserver(syncTabStrip).observe(container, {
        attributes: true,
        attributeFilter: ['data-sh-image-set'],
      });
    }
    syncTabStrip();
  }

  function init() {
    document.querySelectorAll('[data-sh-gallery-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
